import { buildModelManager } from "../builder.js";
const DefaultMessageSelection = {
  __typename: true,
  id: true,
  attributedShopifyOrderId: true,
  campaignId: true,
  channel: true,
  contactId: true,
  content: true,
  conversationId: true,
  createdAt: true,
  customerId: true,
  deliveredAt: true,
  direction: true,
  document: { url: true, mimeType: true, fileName: true },
  failedAt: true,
  failedReason: true,
  hasFlowButton: true,
  image: { url: true, mimeType: true, fileName: true },
  isAiGenerated: true,
  isFlowButtonResponse: true,
  isPreWrittenMessage: true,
  isQuickReply: true,
  isScenarioTrigger: true,
  isTest: true,
  isWaitingForWhatsappMessageStatusChange: true,
  isWhatsAppOrder: true,
  messageSkeletonId: true,
  nodeAfterStatusChangeId: true,
  readAt: true,
  replyButtonId: true,
  replyListId: true,
  scenarioId: true,
  sentAt: true,
  status: true,
  turnoverFromExternalSource: true,
  updatedAt: true,
  video: { url: true, mimeType: true, fileName: true },
  voice: { url: true, mimeType: true, fileName: true },
  whatsappCostInEuros: true,
  whatsappMessageId: true,
  whatsappTemplateId: true
};
const modelApiIdentifier = "message";
const pluralModelApiIdentifier = "messages";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByWhatsappMessageId",
    findByField: "whatsappMessageId",
    findByVariableName: "whatsappMessageId",
    modelApiIdentifier,
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByWhatsappMessageId",
    findByField: "whatsappMessageId",
    findByVariableName: "whatsappMessageId",
    modelApiIdentifier,
    defaultSelection: DefaultMessageSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createMessage",
    operationReturnType: "CreateMessage",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { message: { required: false, type: "CreateMessageInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMessageSelection
  },
  {
    type: "action",
    operationName: "bulkCreateMessages",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateMessagesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultMessageSelection
  },
  {
    type: "action",
    operationName: "updateMessage",
    operationReturnType: "UpdateMessage",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      message: { required: false, type: "UpdateMessageInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMessageSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateMessages",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateMessagesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultMessageSelection
  },
  {
    type: "action",
    operationName: "deleteMessage",
    operationReturnType: "DeleteMessage",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteMessages",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertMessage",
    operationReturnType: "UpsertMessage",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      message: { required: false, type: "UpsertMessageInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateMessageResult": { hasReturnType: false },
      "... on UpdateMessageResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMessageSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertMessages",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertMessagesInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultMessageSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "messageGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const MessageManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultMessageSelection,
  operations
);
export {
  DefaultMessageSelection,
  MessageManager
};
//# sourceMappingURL=Message.js.map
